module.exports = __webpack_public_path__ + "img/eleganza4_product.8e329f31.webp";